import error from "../Component-Library/Error404";
const URL_DATA = {
  myidm: {
    change_password:
      "https://myidm.mypepsico.com/iam/im/pepsico/ca12/index.jsp?task.tag=PepsicoChangeMyPassword",
    update_phone_email:
      "https://myidm.mypepsico.com/iam/im/pepsico/ca12/index.jsp?task.tag=ProfileUpdate_PhoneandnonPepsiCoemail_usingOneTimePasscode",
    profile_update:
      "https://myidm.mypepsico.com/iam/im/pepsico/ca12/index.jsp?console.tab=%24%7Bbundle%3DresourceBundles.PepsiCo_environment_roles_Tokenized%3Akey%3Dcategory.ManageMyAccount%7D",
    pending_approval:
      "https://myidm.mypepsico.com/iam/im/pepsico/ca12/index.jsp?task.tag=PendingApprovals",
    request_access:
      "https://myidm.mypepsico.com/iam/im/pepsico/ca12/index.jsp?console.tab=%24%7Bbundle%3DresourceBundles.PepsiCo_environment_roles_Tokenized%3Akey%3Dcategory.RequestAccess%7D",
    application_onboarding:
      "https://myidm.mypepsico.com/iam/im/pepsico/ca12/index.jsp?console.tab=%24%7Bbundle%3DresourceBundles.PepsiCo_environment_roles_Tokenized%3Akey%3Dcategory.ManageOtherAccounts%7D&task.clear=1",
    myidm_metrics: "",
  },
  pki: {
    new_certificate_issue:
      "https://pepsico.service-now.com/now/nav/ui/classic/params/target/com.glideapp.servicecatalog_cat_item_view.do%3Fv%3D1%26sysparm_id%3D2a649c570fd9db00ecd0fd4ce1050eaf%26sysparm_link_parent%3D11d60ce50f511700fa1b1b1e51050e82%26sysparm_catalog%3De0d08b13c3330100c8b837659bba8fb4%26sysparm_catalog_view%3Dcatalog_IT_Services_Catalog%26sysparm_view%3Dcatalogs_default",
    revoke_certificate: "https://mycert-pepsico.appvx.com/appviewx/login",
    update_certiifcate:
      "https://pepsico.service-now.com/now/nav/ui/classic/params/target/com.glideapp.servicecatalog_cat_item_view.do%3Fv%3D1%26sysparm_id%3D2a649c570fd9db00ecd0fd4ce1050eaf%26sysparm_link_parent%3D11d60ce50f511700fa1b1b1e51050e82%26sysparm_catalog%3De0d08b13c3330100c8b837659bba8fb4%26sysparm_catalog_view%3Dcatalog_IT_Services_Catalog%26sysparm_view%3Dcatalogs_default",
    certificate_automation:
      "https://pepsico.service-now.com/now/nav/ui/classic/params/target/com.glideapp.servicecatalog_cat_item_view.do%3Fv%3D1%26sysparm_id%3D2a649c570fd9db00ecd0fd4ce1050eaf%26sysparm_link_parent%3D11d60ce50f511700fa1b1b1e51050e82%26sysparm_catalog%3De0d08b13c3330100c8b837659bba8fb4%26sysparm_catalog_view%3Dcatalog_IT_Services_Catalog%26sysparm_view%3Dcatalogs_default",
    update_certiifcate_ownership:
      "https://pepsico.service-now.com/now/nav/ui/classic/params/target/com.glideapp.servicecatalog_cat_item_view.do%3Fv%3D1%26sysparm_id%3D2a649c570fd9db00ecd0fd4ce1050eaf%26sysparm_link_parent%3D11d60ce50f511700fa1b1b1e51050e82%26sysparm_catalog%3De0d08b13c3330100c8b837659bba8fb4%26sysparm_catalog_view%3Dcatalog_IT_Services_Catalog%26sysparm_view%3Dcatalogs_default",
    cross_functional_integration:
      "https://pepsico.service-now.com/now/nav/ui/classic/params/target/com.glideapp.servicecatalog_cat_item_view.do%3Fv%3D1%26sysparm_id%3D2a649c570fd9db00ecd0fd4ce1050eaf%26sysparm_link_parent%3D11d60ce50f511700fa1b1b1e51050e82%26sysparm_catalog%3De0d08b13c3330100c8b837659bba8fb4%26sysparm_catalog_view%3Dcatalog_IT_Services_Catalog%26sysparm_view%3Dcatalogs_default",
    ca_management:
      "https://pepsico.service-now.com/now/nav/ui/classic/params/target/com.glideapp.servicecatalog_cat_item_view.do%3Fv%3D1%26sysparm_id%3D2a649c570fd9db00ecd0fd4ce1050eaf%26sysparm_link_parent%3D11d60ce50f511700fa1b1b1e51050e82%26sysparm_catalog%3De0d08b13c3330100c8b837659bba8fb4%26sysparm_catalog_view%3Dcatalog_IT_Services_Catalog%26sysparm_view%3Dcatalogs_default",
    hsm_access_provisioning_and_management:
      "https://pepsico.service-now.com/now/nav/ui/classic/params/target/com.glideapp.servicecatalog_cat_item_view.do%3Fv%3D1%26sysparm_id%3D2a649c570fd9db00ecd0fd4ce1050eaf%26sysparm_link_parent%3D11d60ce50f511700fa1b1b1e51050e82%26sysparm_catalog%3De0d08b13c3330100c8b837659bba8fb4%26sysparm_catalog_view%3Dcatalog_IT_Services_Catalog%26sysparm_view%3Dcatalogs_default",
    hsm_monitoring_and_maintenance:
      "https://pepsico.service-now.com/now/nav/ui/classic/params/target/com.glideapp.servicecatalog_cat_item_view.do%3Fv%3D1%26sysparm_id%3D2a649c570fd9db00ecd0fd4ce1050eaf%26sysparm_link_parent%3D11d60ce50f511700fa1b1b1e51050e82%26sysparm_catalog%3De0d08b13c3330100c8b837659bba8fb4%26sysparm_catalog_view%3Dcatalog_IT_Services_Catalog%26sysparm_view%3Dcatalogs_default",
    dashboard_and_metrics: "",
  },
  sso: {
    app_onboarding_saml_oidc: "https://devx-infra.mypepsico.com/sso-okta-onboarding",
    consumer_portal:
      "https://consumer-pepsico-admin.okta.com/admin/apps/active",
    saml_app_onboarding: "https://devx-infra.mypepsico.com/sso-okta-onboarding",
    partner_portal: "https://pepsico-admin.okta.com/admin/apps/active",
    dashboard_and_metrics:
      "https://secure-admin-consumer.pepsico.com/dashboard",
  },
  active_directory: {
    azure_app_onbd: "",
    ad_group_managment: "",
    dashboard_and_metricst: "",
  },
  mypam: {
    service_amount_onbd: "",
    dashboard_and_metrics: "",
  },
  pep_agm: {
    access_certification:
      "https://pepagmadmin.mypepsico.com/eurekify/portal/home",
    revoke_access: "https://pepagmadmin.mypepsico.com/eurekify/portal/home",
    identity_governance:
      "https://pepagmadmin.mypepsico.com/eurekify/portal/home",
    dashboard_metrics: "https://pepagmadmin.mypepsico.com/eurekify/portal/home",
  },
  approval: {
    pending_approval:
      "https://myidm.mypepsico.com/iam/im/pepsico/ca12/index.jsp?task.tag=PendingApprovals",
  },
};

const URL_FINAL = {
  myidM: {
    "Access Requests Management": {
      "Request Access - New":
        "https://myidm.mypepsico.com/iam/im/pepsico/ca12/index.jsp?console.tab=%24%7Bbundle%3DresourceBundles.PepsiCo_environment_roles_Tokenized%3Akey%3Dcategory.RequestAccess%7D",
      "Request New Access - Others":
        "https://myidm.mypepsico.com/iam/im/pepsico/ca12/index.jsp?console.tab=%24%7Bbundle%3DresourceBundles.PepsiCo_environment_roles_Tokenized%3Akey%3Dcategory.RequestAccess%7D",
      "Modify Access   - Self":
        "https://myidm.mypepsico.com/iam/im/pepsico/ca12/index.jsp?console.tab=%24%7Bbundle%3DresourceBundles.PepsiCo_environment_roles_Tokenized%3Akey%3Dcategory.RequestAccess%7D",
      "Modify Access   - Others":
        "https://myidm.mypepsico.com/iam/im/pepsico/ca12/index.jsp?console.tab=%24%7Bbundle%3DresourceBundles.PepsiCo_environment_roles_Tokenized%3Akey%3Dcategory.RequestAccess%7D",
      "SAP Access":
        "https://myidm.mypepsico.com/iam/im/pepsico/ca12/index.jsp?console.tab=%24%7Bbundle%3DresourceBundles.PepsiCo_environment_roles_Tokenized%3Akey%3Dcategory.RequestSAPAccess%7D&task.clear=1",
    },
    "Self-Service Account Management": {
      "Change Password": "",
      "Profile Update":
        "https://myidm.mypepsico.com/iam/im/pepsico/ca12/index.jsp?console.tab=%24%7Bbundle%3DresourceBundles.PepsiCo_environment_roles_Tokenized%3Akey%3Dcategory.ManageOtherAccounts%7D&task.clear=1",
      "Manage Proffile update  -  others":
        "https://myidm.mypepsico.com/iam/im/pepsico/ca12/index.jsp?console.tab=%24%7Bbundle%3DresourceBundles.PepsiCo_environment_roles_Tokenized%3Akey%3Dcategory.ManageOtherAccounts%7D&task.clear=1",
      "Extension & Reactivation Request":
        "https://myidm.mypepsico.com/iam/im/pepsico/ca12/index.jsp?console.tab=%24%7Bbundle%3DresourceBundles.PepsiCo_environment_roles_Tokenized%3Akey%3Dcategory.ManageOtherAccounts%7D&task.clear=1",
      "Termination Request":
        "https://myidm.mypepsico.com/iam/im/pepsico/ca12/index.jsp?console.tab=%24%7Bbundle%3DresourceBundles.PepsiCo_environment_roles_Tokenized%3Akey%3Dcategory.ManageOtherAccounts%7D&task.clear=1",
      "Profile Update OTP":
        "https://myidm.mypepsico.com/iam/im/pepsico/ca12/index.jsp?console.tab=%24%7Bbundle%3DresourceBundles.PepsiCo_environment_roles_Tokenized%3Akey%3Dcategory.ManageOtherAccounts%7D&task.clear=1",
      "Change Security Questions / Answers {Password Hint}":
        "https://myidm.mypepsico.com/iam/im/pepsico/ca12/index.jsp?console.tab=%24%7Bbundle%3DresourceBundles.PepsiCo_environment_roles_Tokenized%3Akey%3Dcategory.ManageOtherAccounts%7D&task.clear=1",
    },
    "BOT Management": {
      "Create BOT IDs":
        "https://myidm.mypepsico.com/iam/im/pepsico/ca12/index.jsp?console.tab=%24%7Bbundle%3DresourceBundles.PepsiCo_environment_roles_Tokenized%3Akey%3Dcategory.ManageOtherAccounts%7D&task.clear=1",
    },
    "Application Self Integration": {
      "Application Self Integration":
        "https://myidm.mypepsico.com/iam/im/pepsico/ca12/index.jsp?console.tab=%24%7Bbundle%3DresourceBundles.PepsiCo_environment_roles_Tokenized%3Akey%3Dcategory.ManageOtherAccounts%7D&task.clear=1",
    },
    "Approval Request": {
      "View & Approve the Access Request": "",
    },
  },
  Directory_Services: {
    "Active Directory": {},
    "Entra ID": {},
    "Enterprise Directory": {
      "View & Approve myidM Request": "",
      "CMP Requests - Attribute Creation": "",
      "CMP Requests - System Account Creation": "",
      "CMP Requests - Group Creation": "",
      "IDX ITE Bulk Password Reset":
        "https://t01lap01618.corp.pep.tst:8443/testpw",
      "myITS Service Request - Open": "",
      "myITS Incident - Open": "",
      "myITS Security Incident - Open": "",
      "myITS - CTO OPS Review Metrics - IDX":
        "https://pepsico.service-now.com/now/nav/ui/classic/params/target/%24pa_dashboard.do%3Fsysparm_dashboard%3Df5138b0f1b06a4d0b182fc87dc4bcb8a%26sysparm_tab%3D2c3b4acd1b92e454e30e315f034bcbf4%26sysparm_cancelable%3Dtrue%26sysparm_editable%3Dundefined%26sysparm_active_panel%3Dfalse",
      "Reporting Setup": "",
      "Patching Status": "",
      "IDX Certificate Expiration (servers, LB, Instances)": "",
      "Servers usage (Dashboard)": "",
      "IDX BOT IDs requests": "",
    },
  },
  PKI_Digital_Certificate_Services: {
    "PKI - Digital Certificate Services": {
      "Certificate Lifecycle Management - Certificate Issue": "",
      "Certificate Lifecycle Management - Renew Certificate": "",
      "Certificate Lifecycle Management - Revoke Certificate": "",
      "Certificate Lifecycle Management - Update Certificate(s)": "",
      "Certificate Lifecycle Management - Certificate Automation": "",
      "Certificate Lifecycle Management - Update Certificate Ownership": "",
      "Custom Certificate Solutions - Cross functional Integrations": "",
      "ADCS and Public CA Maintenance and management (CA MAnagement)": "",
      "Define and enforce encryption standards": "",
      "Hardware Security Module (HSM) Management  - HSM Access Provisioning and Management":
        "",
      "Hardware Security Module (HSM) Management - HSM Integration": "",
      "Hardware Security Module (HSM) Management - HSM Monitoring and Maintenance":
        "",
    },
  },
  Associate_SSO: {
    "Associate SSO": {
      "Single Sign on (SSO) and MFA integration": "",
      "API Access management": "",
      "Retire Application": "",
      "Update encryption certificate for application": "",
      "Dashboard - Application usage metrics": "",
      "Dashboard - Total logins and MFA metrics": "",
      "Dashboard -  Denied suspicious logins and IPs": "",
      "Request for MFA reset": "",
    },
  },
  Customer_Identity_and_Access_Management_CIAM: {
    "Consumer IAM": {},
    "Partner IAM": {},
  },
  PepAGM: {
    "Access recertification": {
      "Active Campaigns": "",
    },
    "Recerification Monitoring": {},
  },
  myPAM: {},
};
const OPEN_URL_CHECKER = (mainId, navIdOpen) => {
  if (URL_DATA[mainId][navIdOpen]) {
    const secretPepsicoUrl = window.open(
      URL_DATA[mainId][navIdOpen],
      "_blank",
    );
  } else {
    const winHtml = error.Error404Page;

    const winUrl = URL.createObjectURL(
      new Blob([winHtml], { type: "text/html" })
    );
    const win = window.open(
      winUrl,
      "_blank"
    );
    setTimeout(() => {
      win.close();
    }, 5000);
  }
};

const OPEN_EMPTY_URL = () => {
  const winHtml = error.Error404Page;
  const winUrl = URL.createObjectURL(
    new Blob([winHtml], { type: "text/html" })
  );
  const win = window.open(
    winUrl,
    "_blank"
  );
  setTimeout(() => {
    win.close();
  }, 5000);
};
export default {
  OPEN_URL_CHECKER,
  OPEN_EMPTY_URL,
};
